import React from "react";
import styles from "./input.module.css";
import { Col, Container, Row } from "react-bootstrap";

const InputboxSection = () => {
  return (
    <React.Fragment>
      <div className={styles.main_Section}>
        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.left_section}>
                <h6>Join the Digital Revolution 🚀</h6>
                <p>Sign up for industry insights, tech trends, and exclusive offers.</p>
              </div>
            </Col>
            <Col md={6} sm={12}>
              <div className={styles.right_section}>
                <input type="text" placeholder="Enter Your Email" inputMode="email" />
                <button>Send</button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InputboxSection;
